import React from "react";
import mobileImg from "../Images/phone.png";

const Downloadapp = () => {
  return (
    <section className="container my-5 py-5">
      <div
        className="row align-items-center justify-content-between rounded-5 px-4 py-5"
        style={{
          backgroundColor: "#ffffff", // clean white background
          boxShadow: "0 15px 40px rgba(0,0,0,0.08)", // soft shadow
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
        {/* Decorative Shape - Left */}
        <div
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            background: "rgba(52,168,83,0.15)",
            borderRadius: "160px 160px 0 0",
            top: "-150px",
            left: "-150px",
            zIndex: 0,
          }}
        />

        {/* LEFT TEXT */}
        <div className="col-lg-6 text-start position-relative" style={{ zIndex: 1 }}>
          <small className="text-success fw-bold text-uppercase">
            Download Our App
          </small>

          <h2 className="fw-bold mt-3 lh-sm" style={{ fontSize: "2.6rem", color: "#333" }}>
            Get Groceries<br />
            Delivered Fast & Easy
          </h2>

          <p className="text-muted mt-3 mb-4 fs-5">
            Grab fresh groceries, daily essentials, and more delivered directly from local stores with our fast, secure, and intuitive mobile app.
          </p>

          {/* CTA Buttons */}
          <div className="d-flex gap-3">
            {/* Play Store */}
            <a
              href="https://play.google.com/store/apps/details?id=com.dectwin.fresh_mart&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-success btn-lg d-flex align-items-center px-4 py-3 shadow-lg"
              style={{
                fontSize: "1.1rem",
                borderRadius: "50px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
                e.target.style.boxShadow = "0px 6px 18px rgba(0,0,0,0.25)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "0px 4px 10px rgba(0,0,0,0.15)";
              }}
            >
              <i className="bi bi-google-play fs-4 me-2"></i> Get it on Play Store
            </a>
          </div>
        </div>

        {/* RIGHT PHONE IMAGE */}
        <div className="col-lg-5 d-flex justify-content-center justify-content-lg-end mt-4 mt-lg-0 position-relative" style={{ zIndex: 1 }}>
          <img
            src={mobileImg}
            alt="Mobile App"
            className="img-fluid"
            style={{
              maxHeight: "550px",
              transform: "translateX(0px)",
              transition: "transform 0.4s ease",
            }}
            onMouseEnter={(e) => (e.target.style.transform = "translateY(-10px) scale(1.05)")}
            onMouseLeave={(e) => (e.target.style.transform = "translateY(0px) scale(1)")}
          />
        </div>
      </div>
    </section>
  );
};

export default Downloadapp;
